/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_wu_letters_intro = /** @type {(inputs: { letters: NonNullable<unknown> }) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`All the words you can spell with the letters ${i?.letters}, longest first — with exact anagrams highlighted.`)
};

const es_wu_letters_intro = /** @type {(inputs: { letters: NonNullable<unknown> }) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Todas las palabras que puedes formar con las letras ${i?.letters}, de más larga a más corta, con los anagramas exactos destacados.`)
};

const de_wu_letters_intro = /** @type {(inputs: { letters: NonNullable<unknown> }) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Alle Wörter, die du mit den Buchstaben ${i?.letters} bilden kannst, längste zuerst – exakte Anagramme sind hervorgehoben.`)
};

const nl_wu_letters_intro = /** @type {(inputs: { letters: NonNullable<unknown> }) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Alle woorden die je kunt spellen met de letters ${i?.letters}, langste eerst — met exacte anagrammen gemarkeerd.`)
};

const fr_wu_letters_intro = /** @type {(inputs: { letters: NonNullable<unknown> }) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Tous les mots que vous pouvez former avec les lettres ${i?.letters}, du plus long au plus court — les anagrammes exacts sont mis en évidence.`)
};

const it_wu_letters_intro = /** @type {(inputs: { letters: NonNullable<unknown> }) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Tutte le parole che puoi scrivere con le lettere ${i?.letters}, dalla più lunga — con gli anagrammi esatti evidenziati.`)
};

const pt_br2_wu_letters_intro = /** @type {(inputs: { letters: NonNullable<unknown> }) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Todas as palavras que você pode formar com as letras ${i?.letters}, da mais longa para a mais curta — com os anagramas exatos em destaque.`)
};

const pt_wu_letters_intro = /** @type {(inputs: { letters: NonNullable<unknown> }) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Todas as palavras que pode soletrar com as letras ${i?.letters}, da mais longa — com os anagramas exatos destacados.`)
};

const ja_wu_letters_intro = /** @type {(inputs: { letters: NonNullable<unknown> }) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.letters} の文字で綴れるすべての単語を、長い順に表示します — 完全一致のアナグラムはハイライト表示されます。`)
};

const zh_wu_letters_intro = /** @type {(inputs: { letters: NonNullable<unknown> }) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`用字母 ${i?.letters} 能拼出的所有单词，按最长优先排列——完全匹配的易位构词会特别标出。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{ letters: NonNullable<unknown> }} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const wu_letters_intro = (inputs, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.wu_letters_intro(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("wu_letters_intro", locale)
	if (locale === "en") return en_wu_letters_intro(inputs)
	if (locale === "es") return es_wu_letters_intro(inputs)
	if (locale === "de") return de_wu_letters_intro(inputs)
	if (locale === "nl") return nl_wu_letters_intro(inputs)
	if (locale === "fr") return fr_wu_letters_intro(inputs)
	if (locale === "it") return it_wu_letters_intro(inputs)
	if (locale === "pt-BR") return pt_br2_wu_letters_intro(inputs)
	if (locale === "pt") return pt_wu_letters_intro(inputs)
	if (locale === "ja") return ja_wu_letters_intro(inputs)
	return zh_wu_letters_intro(inputs)
};